import { Component, ContentChild, TemplateRef } from '@angular/core';
import { connectStats } from 'instantsearch.js/es/connectors';
import { BaseWidget } from './base-widget';
import { AlgoliaSearchResults } from './search.types';

interface StatsState {
  nbHits: number;
  nbPages: number;
  page: number;
  processingTimeMS: number;
  query: string;
  params: string;
  index: string;
}

@Component({
  selector: 'app-stats',
  template: `
    <ng-container *ngIf="state && resultTemplate">
      <ng-container *ngTemplateOutlet="resultTemplate; context: { state: state }" />
    </ng-container>
  `
})
export class StatsComponent extends BaseWidget<StatsState> {
  @ContentChild(TemplateRef) resultTemplate?: TemplateRef<{}>;

  createWidget() {
    return connectStats((renderState, isFirstRender) => {
      if (isFirstRender) return;

      const index = this.algoliaService.instance.indexName;
      const results = this.algoliaService.instance.helper?.lastResults as
        | AlgoliaSearchResults
        | undefined;
      const params = results?.params ?? '';

      this.updateState({
        nbHits: renderState.nbHits,
        nbPages: renderState.nbPages,
        page: renderState.page,
        processingTimeMS: renderState.processingTimeMS,
        query: renderState.query,
        params: params,
        index: index
      });
    })({});
  }
}
